// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__32UlZ","label":"Completed_label__1JaJk"};